export const state = {
    status: '',
    balance: null,
    senders: null,
}; 